export default "__VITE_ASSET__ceb7448c__"